import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';

export const RANGE_OPTIONS = ['1d', '7d', '30d', '90d', '365d'] as const;
export type RangeOption = (typeof RANGE_OPTIONS)[number];

export const DEFAULT_RANGE: RangeOption = '7d';

export const RANGE_DAYS: Record<RangeOption, number> = {
  '1d': 1,
  '7d': 7,
  '30d': 30,
  '90d': 90,
  '365d': 365,
};

export const isRangeOption = (value: string | null): value is RangeOption =>
  RANGE_OPTIONS.includes(value as RangeOption);

export const useRangeFromUrl = (): [RangeOption, (value: RangeOption) => void] => {
  const [searchParams, setSearchParams] = useSearchParams();
  const rangeParam = searchParams.get('range');
  const activeRange: RangeOption = isRangeOption(rangeParam) ? rangeParam : DEFAULT_RANGE;

  const setRange = useCallback(
    (value: RangeOption) => {
      setSearchParams(
        (prev) => {
          const next = new URLSearchParams(prev);
          next.set('range', value);
          return next;
        },
        { replace: true }
      );
    },
    [setSearchParams]
  );

  return [activeRange, setRange];
};
